import ProductText from "../Component/ProductText";

function Layout4(props) {
  const { childComp, cardAnimationClass } = props

  function renderLayout4() {
    return (
      <div className={`tw-flex tw-flex-col tw-gap-[24px]`}>
        <div className="tw-flex tw-flex-col">
        {childComp()}
        </div>
        <div className={cardAnimationClass}>{<ProductText {...props} />}</div>
      </div>
    )
  }

  return (
    <>
      {renderLayout4()}
    </>
  )
}

export default Layout4;